import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { failed: boolean };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Kyndo interface error", error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <main className="fatal-state container">
        <span className="eyebrow">Interface interrupted</span>
        <h1>The contracts are unaffected.</h1>
        <p>
          The interface encountered an unexpected browser error. Reload to
          restore the latest public state from Base.
        </p>
        <button
          className="button primary"
          type="button"
          onClick={() => window.location.reload()}
        >
          Reload Kyndo
        </button>
      </main>
    );
  }
}
